import type { Link } from './link';
import type { NetMessage } from './protocol';

/**
 * A link that carries messages through the lobby server's WebSocket instead of a direct WebRTC
 * connection. Used when the direct connection cannot be made: some home routers do not let two
 * devices behind them reach each other by the public address, and browsers hide local addresses.
 * Slower than a direct link, but lockstep traffic is light.
 */
export class RelayLink implements Link {
  onMessage: ((m: unknown) => void) | null = null;
  onClose: (() => void) | null = null;
  rtt = 100;
  open = true;

  constructor(readonly remoteId: string, private sendRaw: (data: string) => void, private onClosed: () => void) {}

  send(m: NetMessage): void {
    if (this.open) this.sendRaw(JSON.stringify(m));
  }

  receive(data: string): void {
    if (!this.open) return;
    try {
      this.onMessage?.(JSON.parse(data));
    } catch {
      /* drop malformed */
    }
  }

  close(): void {
    if (!this.open) return;
    this.open = false;
    this.onClosed();
    this.onClose?.();
  }
}
